let currency = '';

function getCurrencySymbol() {
  if (!currency) currency = sessionStorage.getItem('currency');

  const symbols = {
    USD: '\u0024', // US Dollar ($)
    INR: '\u20B9', // Indian Rupee (₹)
    IDR: '\u0052\u0070', // Indonesian Rupiah (Rp)
    MYR: '\u0052\u004D', // Malaysian Ringgit (RM)
    THB: '\u0E3F', // Thai Baht (฿)
    BDT: '\u09F3', // Bangladesh Taka (৳)
    EUR: '\u20AC', // Euro (€)
    GBP: '\u00A3', // British Pound (£)
    JPY: '\u00A5', // Japanese Yen (¥)
    CNY: '\u5143', // Chinese Yuan (元/¥)
    KRW: '\u20A9', // South Korean Won (₩)
    PKR: '\u20A8', // Pakistani Rupee (₨)
    LKR: '\u20A8', // Sri Lankan Rupee (₨)
    NPR: '\u20A8', // Nepalese Rupee (₨)
    AUD: '\u0024', // Australian Dollar (A$)
    CAD: '\u0024', // Canadian Dollar (C$)
    CHF: '\u20A3', // Swiss Franc (₣)
    RUB: '\u20BD', // Russian Ruble (₽)
    ZAR: '\u0052', // South African Rand (R)
    BRL: '\u0052\u0024', // Brazilian Real (R$)
    MXN: '\u0024', // Mexican Peso (Mex$)
    AED: '\u062F\u002E\u0625', // UAE Dirham (د.إ)
    SAR: '\uFDFC', // Saudi Riyal (﷼)
    TRY: '\u20BA', // Turkish Lira (₺)
    SGD: '\u0024', // Singapore Dollar (S$)
    HKD: '\u0024', // Hong Kong Dollar (HK$)
    NZD: '\u0024', // New Zealand Dollar (NZ$)
  };

  // Return the currency symbol or default to INR
  return symbols[currency] || symbols.INR;
}

export default getCurrencySymbol;
